<template>
  <page :manualInit="init" :manualErr="initErrs" v-scroll="onScroll">
    <v-layout row wrap>
      <v-flex offset-xs3 xs6>
        <v-layout row wrap>
          <transition-group name="slide-x-transition" tag="div" class="flex">
            <v-flex xs12 v-for="(job, idx) in jobs" :key="job.id" class="pt-3">
              <v-subheader v-if="isNewSort(job.effDate, idx)">{{formatDisplayDate(job.effDate)}}</v-subheader>
              <v-expansion-panel class="jobCard">
                <v-expansion-panel-content :hide-actions="job.init === 0">
                  <div slot="header">
                    <v-layout row align-center>
                      <div class="fileFormat">
                        <v-icon :color="getReportFormat(job.fileFormat).color">{{getReportFormat(job.fileFormat).icon}}</v-icon>
                      </div>
                      <div class="jobContent">
                        <div>
                          {{job.customName}}
                        </div>
                        <div>
                          <span class="caption grey--text">{{formatDisplayDateTime(job.effDate)}}</span>
                        </div>
                        <div v-if="job.downloading">
                          <v-progress-linear :indeterminate="true" color="purple"></v-progress-linear>
                        </div>
                        <div v-else>
                          <v-progress-linear :indeterminate="true" v-if="job.init === 0"></v-progress-linear>
                          <v-progress-linear :value="100" color="red" v-else-if="job.init === 2"></v-progress-linear>
                        </div>
                      </div>
                      <div class="jobAction">
                        <div v-if="job.init === 1">
                          <v-btn icon @click.stop="doDownload(job)" title="Download">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        </div>
                        <div v-else-if="job.init === 2">
                          <v-btn icon @click.stop="doRetry(job)" title="Retry">
                            <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                        </div>
                        <div v-else-if="job.init === 0">
                          <v-btn icon @click.stop="deleteJob(job)" title="Delete">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-layout>
                  </div>
                  <div v-if="job.init !== 0">
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12 md6>
                              <span class="grey--text body-2">ID: </span> {{job.id}}
                            </v-flex>
                            <v-flex xs12 md6></v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'proposalNo')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'proposalNo') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'proposalNo') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'certType')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'certType') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'certType') }}
                            </v-flex>
                            <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfOriginalCopies')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'numberOfOriginalCopies') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'numberOfOriginalCopies') }}
                            </v-flex>
                            <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfCopies')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'numberOfCopies') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'numberOfCopies') }}
                            </v-flex>
                            <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfCopies')"></v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'intermediary')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'intermediary') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'intermediary') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'product')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'product') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'product') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'scheme')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'scheme') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'scheme') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'status')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'status') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'status') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'appID')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'appID') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'appID') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'clmStatus')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'clmStatus') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'clmStatus') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'duration')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'duration') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'duration') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'typeOfCover')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'typeOfCover') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'typeOfCover') }}
                            </v-flex>
                            <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'businessSource')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'businessSource') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'businessSource') }}
                            </v-flex>
                            <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'fromDate')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'fromDate') }}</span>
                              {{ extractValue(job.formattedRptKeys, 'fromDate') }}
                            </v-flex>
                            <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'toDate')">
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'toDate') }} </span>
                              {{ extractValue(job.formattedRptKeys, 'toDate') }}
                            </v-flex>
                            <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'toDate')"></v-flex>
                            <v-flex xs12 md4>
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'format') }} </span>
                              {{ extractValue(job.formattedRptKeys, 'format') }}
                            </v-flex>
                            <v-flex xs12 md4>
                              <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'sendEmail') }} </span>
                              {{ extractValue(job.formattedRptKeys, 'sendEmail') }}
                            </v-flex>
                            <v-flex xs12 md4></v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-flex xs12 md6>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-btn v-if="job.init === 2" color="orange darken-1" flat="flat" @click="showErrorDialog(job)">Show Error
                          <v-icon right>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn color="red darken-1" flat="flat" @click="deleteJob(job)">Delete
                          <v-icon right>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </transition-group>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="errorDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Error Log</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <p v-if="selectedJob">
            {{selectedJob.errorMsg}}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="errorDialog=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate2, formatDisplayDateTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { formatProcess } from '@/utils/report'
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import toDate from 'date-fns/toDate'
import { downloadPrompt } from '@/utils/file'

export default {
  data() {
    return {
      init: 0,
      initErrs: [],
      jobs: [],
      menu: {},
      hasMore: true,
      fetchingMore: false,
      selectedJob: undefined,
      errorDialog: false
    }
  },
  computed: {
    processState() {
      return this.$store.state.user.rptJob.rptProcess.processes
    }
  },
  watch: {
    // As process state change is updated via push (websocket), we can only watch state changes in vuex to know the updated state
    'processState': {
      handler: function (values) {
        if (values && values.length > 0) {
          values.map(value => {
            const jobsFilter = this.jobs.filter(job => job.id === value.id)
            if (jobsFilter && jobsFilter.length > 0) {
              jobsFilter[0].init = value.init
              jobsFilter[0].errorMsg = value.errorMsg
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      // Init state
      this.init = 0
      this.initErrs = []
      const apiURI = this.$store.state.app.menu.rptHistory
      if (apiURI) {
        try {
          const expand = {}
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
            if (data.data && data.data.length > 0) {
              data.data.map(job => {
                // Follow mutation on rptProcess
                formatProcess(job, job.statusCode)
              })
            }
            this.$set(this, 'jobs', data.data)
          }
          this.init = 1
        } catch (error) {
          console.log(error)
          this.init = 2
        }
      } else {
        this.init = 2
        this.initErrs.push('Invalid API')
      }
    },
    async fetchMore() {
      if (!this.fetchingMore) {
        const apiURI = this.menu.next
        if (apiURI) {
          try {
            this.fetchingMore = true
            const result = await this.$http.get(apiURI)
            const { data } = result
            if (data) {
              this.menu = extractMenu(data._links)
              if (data.data && data.data.length > 0) {
                data.data.map(job => {
                  // Follow mutation on rptProcess
                  formatProcess(job, job.statusCode)
                })
                this.jobs.push(...data.data)
              } else {
                this.hasMore = false
              }
            }
            this.fetchingMore = false
          } catch (error) {
            console.log(error)
            this.fetchingMore = false
          }
        } else {
          this.init = 2
          this.initErrs.push('Invalid API')
        }
      }
    },
    getReportFormat(format) {
      format = format.toUpperCase()
      const result = reportFormat[format]
      if (result) {
        return result
      } else {
        return {
          icon: 'mdi-file-document',
          color: 'blue'
        }
      }
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate2(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    dateFormat(myDate) {
      try {
        const d = toDate(myDate)
        d.setHours(12)
        d.setMinutes(0)
        d.setSeconds(0)
        d.setMilliseconds(0)
        return d
      } catch (err) {
        console.log(err)
      }
    },
    isNewSort(myDate, idx) {
      if (idx === 0) {
        return true
      } else {
        if (this.dateFormat(myDate).getTime() !== this.dateFormat(this.jobs[idx - 1].effDate).getTime()) {
          return true
        } else {
          return false
        }
      }
    },
    onScroll(e) {
      const offset = window.pageYOffset || document.documentElement.scrollTop
      if (this.hasMore && document.body.scrollHeight <= offset + 300 + window.innerHeight) {
        this.fetchMore()
      }
    },
    async deleteJob(job) {
      this.selectedJob = job
      const apiURI = this.$store.state.app.menu.rptDelete
      if (apiURI) {
        try {
          const expand = {
            id: this.selectedJob.id
          }
          await this.$http.delete(expandURI(apiURI, expand))
          this.jobs.splice(this.jobs.indexOf(this.jobs.find(job => job.id === this.selectedJob.id)), 1)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.notify('Invalid API URL')
      }
    },
    async doDownload(job) {
      this.selectedJob = job
      if (this.selectedJob && this.selectedJob.init === 1) {
        const apiURI = this.$store.state.app.menu.rptDownload
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedJob.id
            }
            this.selectedJob.downloading = true

            const result = await this.$http.get(expandURI(apiURI, expand), {
              responseType: 'blob'
            })
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            downloadPrompt(blob, filename)

            this.selectedJob.downloading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              // As the request is requesting blob, error has to be formatted back to json
              try {
                const errUrl = URL.createObjectURL(data)
                const errRes = await this.$http.get(errUrl)
                URL.revokeObjectURL(errUrl)
                if (errRes.data) {
                  this.notify(errRes.data)
                }
              } catch (err2) {
                console.log(err2)
              }
            }
            this.selectedJob.downloading = false
          }
        } else {
          this.notify('Invalid API URL')
        }
      }
    },
    async doRetry(job) {
      this.selectedJob = job
      if (this.selectedJob && this.selectedJob.init === 2) {
        const apiURI = this.$store.state.app.menu.rptReprocess
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedJob.id
            }
            const result = await this.$http.post(expandURI(apiURI, expand))
            const { data } = result
            if (data.data) {
              formatProcess(data.data, data.data.statusCode)
              const index = this.jobs.indexOf(this.jobs.find(job => job.id === this.selectedJob.id))

              // has to use this.$set as data in obj or arr has no reactivity
              this.$set(this.jobs, index, data.data)
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.notify('Invalid API URL')
        }
      }
    },
    showErrorDialog(job) {
      this.selectedJob = job
      this.errorDialog = true
    },
    extractLabel(formattedRptKeys, objectKey) {
      let result = ''
      if (formattedRptKeys !== undefined && formattedRptKeys !== null && formattedRptKeys !== '') {
        JSON.parse(formattedRptKeys, (key, value) => {
          if (objectKey === key && objectKey === 'proposalNo') {
            result = 'Proposal No: '
          } else if (objectKey === key && objectKey === 'certType') {
            result = 'Type of Certificate: '
          } else if (objectKey === key && objectKey === 'numberOfOriginalCopies') {
            result = 'No. of Original Copies: '
          } else if (objectKey === key && objectKey === 'numberOfCopies') {
            result = 'No. of Copies: '
          } else if (objectKey === key && objectKey === 'intermediary') {
            result = 'Intermediary: '
          } else if (objectKey === key && objectKey === 'product') {
            result = 'Product: '
          } else if (objectKey === key && objectKey === 'scheme') {
            result = 'Scheme: '
          } else if (objectKey === key && objectKey === 'status') {
            result = 'Status: '
          } else if (objectKey === key && objectKey === 'appID') {
            result = 'Claim Type: '
          } else if (objectKey === key && objectKey === 'clmStatus') {
            result = 'Claim Status: '
          } else if (objectKey === key && objectKey === 'duration') {
            result = 'Duration: '
          } else if (objectKey === key && objectKey === 'typeOfCover') {
            result = 'Type of Cover: '
          } else if (objectKey === key && objectKey === 'businessSource') {
            result = 'Business Source: '
          } else if (objectKey === key && objectKey === 'fromDate') {
            result = 'From Date: '
          } else if (objectKey === key && objectKey === 'toDate') {
            result = 'To Date: '
          } else if (objectKey === key && objectKey === 'format') {
            result = 'Format: '
          } else if (objectKey === key && objectKey === 'sendEmail') {
            result = 'Send Output as Email: '
          }
        })
      }
      return result
    },
    extractValue(formattedRptKeys, objectKey) {
      var temp
      if (formattedRptKeys !== undefined && formattedRptKeys !== null && formattedRptKeys !== '') {
        JSON.parse(formattedRptKeys, (key, value) => {
          if (objectKey === key) {
            temp = value
          }
        })
      }
      return temp
    },
    showRptKey(formattedRptKeys, objectKey) {
      let result = false
      if (formattedRptKeys !== undefined && formattedRptKeys !== null && formattedRptKeys !== '') {
        JSON.parse(formattedRptKeys, (key, value) => {
          if (objectKey === key) {
            result = true
          }
        })
      }
      return result
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.jobCard {
  .v-expansion-panel__header {
    height: auto !important;
  }
  &:hover {
    cursor: pointer;
    background: #f5f5f5;
  }
  .fileFormat {
    padding-right: 10px;
    margin-right: 10px;
    border-right: 1px dotted;
  }
  .jobContent {
    width: 90%;
  }
  .jobAction {
    width: 10%;
    text-align: center;
  }
  .rptKeys {
    list-style-type: none;
    padding-left: 20px;
  }
}
</style>
